var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/no-multi-comp */
import React, { useCallback, useEffect, useRef, useState, } from "react";
import { TrackJS } from "trackjs";
import { map, path, equals, pathOr, isEmpty } from "ramda";
import { Field, Form, Formik } from "formik";
import styled from "styled-components";
import { useFlags } from "launchdarkly-react-client-sdk";
import { initialCardInfo, onCardNumberChange, onExpirationUpdate, onExpiryBlur, validateAddress1, validateCity, validateCreditCard, validateCvv, validateEmail, validateExpirationInput, validateFirstName, validateLastName, validatePhone, validateState, validateZip, } from "helpers/credit_card_form";
import { getRecaptchaToken, loadGoogleRecaptcha, } from "helpers/google_recaptcha";
import Loader from "components/loader";
import MuiTextfield from "components/mui_textfield";
import Overlay from "components/overlay";
import { RequestStatus } from "types/requests";
import MobileCreditCardSubmissionFrame from "./mobile_credit_card_submission_frame";
export var StyledWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root\n  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto;\n  grid-gap: 16px;\n  grid-template-areas:\n    \"header header\"\n    \"firstName lastName\"\n    \"cardNumber cardNumber\"\n    \"expiration cvv\"\n    \"address1 address1\"\n    \"address2 address2\"\n    \"city city\"\n    \"state zip\"\n    ", "\n    ", "\n    \"terms terms\"\n    \"button button\";\n"], ["\n  font-size: 1rem; // 14px based on 14px root font-size; decrease to .875rem for 16px root\n  line-height: 1.5rem; // ~22.5px based on 14px root font-size; decrease to 1.33rem for 16px root\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: auto;\n  grid-gap: 16px;\n  grid-template-areas:\n    \"header header\"\n    \"firstName lastName\"\n    \"cardNumber cardNumber\"\n    \"expiration cvv\"\n    \"address1 address1\"\n    \"address2 address2\"\n    \"city city\"\n    \"state zip\"\n    ", "\n    ", "\n    \"terms terms\"\n    \"button button\";\n"])), function (props) { return props.includeEmailField && "email email"; }, function (props) { return props.includePhoneField && "phone phone"; });
var StyledFormControl = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-area: ", ";\n"], ["\n  grid-area: ", ";\n"])), function (props) { return props.gridArea; });
var StyledSubheader = styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  grid-area: header;\n"], ["\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  grid-area: header;\n"])));
var StyledFormButton = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-height: 4rem;\n  grid-area: button;\n\n  button {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 600;\n    background: #3e5b83;\n    border-radius: 4px;\n\n    &:disabled {\n      cursor: pointer;\n      background-color: #b5b5b5;\n    }\n  }\n"], ["\n  min-height: 4rem;\n  grid-area: button;\n\n  button {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 600;\n    background: #3e5b83;\n    border-radius: 4px;\n\n    &:disabled {\n      cursor: pointer;\n      background-color: #b5b5b5;\n    }\n  }\n"])));
var StyledErrorMessage = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var StyledSubmissionErrorMessage = styled(StyledErrorMessage)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: block;\n  position: relative;\n  bottom: 10px;\n\n  font-size: 16px;\n  color: #e02948;\n"], ["\n  display: block;\n  position: relative;\n  bottom: 10px;\n\n  font-size: 16px;\n  color: #e02948;\n"])));
var StyledProcessingLoader = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  height: 60%;\n  width: 60%;\n  padding-top: 100px;\n\n  font-size: 18px;\n\n  background-color: #ffffff;\n  border-radius: 5px;\n\n  text-align: center;\n"], ["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  height: 60%;\n  width: 60%;\n  padding-top: 100px;\n\n  font-size: 18px;\n\n  background-color: #ffffff;\n  border-radius: 5px;\n\n  text-align: center;\n"])));
export default function CreditCardForm(_a) {
    var merchantInfo = _a.merchantInfo, paymentInfo = _a.paymentInfo, afterProcessedPaymentRequest = _a.afterProcessedPaymentRequest, creditCardRequestStatus = _a.creditCardRequestStatus, submitCreditCardPayment = _a.submitCreditCardPayment, setCreditCardRequestStatus = _a.setCreditCardRequestStatus, 
    // TODO: https://upserve.atlassian.net/browse/HQ-7934
    // includeGratuityField,
    includeEmailField = _a.includeEmailField, includePhoneField = _a.includePhoneField, externalSubmitDisabled = _a.externalSubmitDisabled;
    var timeoutRef = useRef(null);
    // TODO: https://upserve.atlassian.net/browse/HQ-7934
    // Tip handling coming soon...
    // const [tip, setTip] = useState<Money>(Money(0));
    // const [customTipError, setCustomTipError] = useState("");
    var _b = useState(initialCardInfo), cardInfo = _b[0], setCardInfo = _b[1];
    var paymentError;
    if (equals(RequestStatus.FAILURE, creditCardRequestStatus)) {
        paymentError = (React.createElement(StyledSubmissionErrorMessage, { className: "error payment-error" }, pathOr("There was an error processing your request. Please check the form and try again.", ["reason"], afterProcessedPaymentRequest)));
    }
    // form submission
    var ccSubmissionRef = useRef();
    var _c = useState(false), ccFrameActive = _c[0], setCcFrameActive = _c[1];
    var handlePaymentMethodToken = useCallback(function (event) {
        if (!equals("upserve-payments", event.data.source)) {
            return;
        }
        if (timeoutRef.current) {
            // clear timeout after card vaulting
            clearTimeout(timeoutRef.current);
        }
        if (event.data.paymentMethodToken) {
            var paymentMethodToken = event.data.paymentMethodToken;
            submitCreditCardPayment({
                paymentInfo: paymentInfo,
                total: paymentInfo.balanceDue,
                paymentMethodToken: paymentMethodToken,
                cardInfo: cardInfo,
            });
        }
        else {
            TrackJS.track("error vaulting credit card");
            setCreditCardRequestStatus(RequestStatus.FAILURE);
            setCcFrameActive(false);
        }
    }, [cardInfo]);
    useEffect(function () {
        var paymentHandler = function (event) {
            handlePaymentMethodToken(event);
        };
        window.addEventListener("message", paymentHandler);
        loadGoogleRecaptcha();
        return function () {
            window.removeEventListener("message", paymentHandler);
        };
    }, [handlePaymentMethodToken]);
    var flags = useFlags();
    var formSubmit = useCallback(function (values, _a) {
        var setSubmitting = _a.setSubmitting;
        setCreditCardRequestStatus(RequestStatus.REQUESTING);
        setCardInfo(__assign({}, values));
        setCcFrameActive(true);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        var doSubmit = path(["current", "doSubmit"], ccSubmissionRef);
        if (typeof doSubmit === "function") {
            if (flags.oloCreditCardRecaptcha) {
                var onError = function () {
                    return setCreditCardRequestStatus(RequestStatus.FAILURE);
                };
                var onSuccess = doSubmit;
                getRecaptchaToken({ onError: onError, onSuccess: onSuccess });
            }
            else {
                doSubmit();
            }
            timeoutRef.current = setTimeout(function () {
                TrackJS.track("credit card vaulting timed out after 30s");
                setCreditCardRequestStatus(RequestStatus.FAILURE);
                setCcFrameActive(false);
            }, 30000);
        }
        else {
            TrackJS.track("credit card submission frame unavailable for submission");
        }
        setSubmitting(false);
    }, [ccSubmissionRef, creditCardRequestStatus, flags]);
    var ccFieldRef = useRef();
    // form inputs
    var inputs = [
        {
            name: "firstName",
            label: "First Name",
            autocomplete: "given-name",
            validate: validateFirstName,
        },
        {
            name: "lastName",
            label: "Last Name",
            autocomplete: "family-name",
            validate: validateLastName,
        },
        {
            name: "cardNumber",
            label: "Card Number",
            autocomplete: "cc-number",
            type: "number",
            validate: validateCreditCard,
            ref: ccFieldRef,
            onChange: onCardNumberChange,
        },
        {
            name: "expiration",
            label: "Expiration",
            autocomplete: "cc-exp",
            pattern: "[0-9]{2}/[0-9]{2}",
            type: "text",
            validate: validateExpirationInput,
            onChange: onExpirationUpdate,
            placeholder: "MM/YY",
            maxLength: 5,
            onBlur: onExpiryBlur,
        },
        {
            name: "cvv",
            label: "CVV",
            autocomplete: "cc-csc",
            validate: function (value) {
                return validateCvv(value, ccFieldRef.current ? ccFieldRef.current.value : null);
            },
        },
        {
            name: "address1",
            label: "Address 1",
            autocomplete: "address-line1",
            validate: validateAddress1,
        },
        {
            name: "address2",
            label: "Address 2",
            placeholder: "Apartment, suite, unit, etc",
            autocomplete: "address-line2",
        },
        {
            name: "city",
            label: "City",
            autocomplete: "address-level2",
            validate: validateCity,
        },
        {
            name: "state",
            label: "State / Province",
            autocomplete: "address-level1",
            maxLength: 2,
            pattern: "[A-Za-z]+",
            validate: validateState,
        },
        {
            name: "zip",
            label: "Zip / Postal Code",
            autocomplete: "postal-code",
            pattern: "[A-Za-z0-9\\s]+",
            maxLength: 10,
            validate: validateZip,
        },
        // TODO: https://upserve.atlassian.net/browse/HQ-7934
        // includeGratuityField
        //   ? {
        //       name: "gratuity-placeholder",
        //     }
        //   : {},
        includeEmailField
            ? {
                name: "email",
                label: "Email for Receipt",
                autocomplete: "email",
                type: "email",
                validate: validateEmail,
            }
            : {},
        includePhoneField
            ? {
                name: "phone",
                label: "Phone Number (Optional)",
                autocomplete: "tel",
                type: "tel",
                validate: validatePhone,
            }
            : {},
    ].filter(function (x) { return !isEmpty(x); });
    var submitDisabled = function (isValid, dirty) {
        var isFormInvalid = !isValid ||
            (equals(RequestStatus.NOT_STARTED, creditCardRequestStatus) && !dirty);
        // TODO: https://upserve.atlassian.net/browse/HQ-7934
        // const isTipInvalid = !equals(customTipError, "");
        return isFormInvalid; // || isTipInvalid;
    };
    return (React.createElement(React.Fragment, null,
        equals(RequestStatus.REQUESTING, creditCardRequestStatus) && (React.createElement(Overlay, null,
            React.createElement(StyledProcessingLoader, null,
                React.createElement(Loader, null, "We're processing your card...")))),
        ccFrameActive && (React.createElement(MobileCreditCardSubmissionFrame, { key: "ccSubmission", ref: ccSubmissionRef, card: cardInfo, merchantKey: merchantInfo.ugMerchantKey, hasRecaptchaInput: flags.oloCreditCardRecaptcha })),
        React.createElement(Formik, { initialValues: {
                firstName: cardInfo.firstName,
                lastName: cardInfo.lastName,
                cardNumber: cardInfo.cardNumber,
                expiryMonth: cardInfo.expiryMonth,
                expiryYear: cardInfo.expiryYear,
                expiration: cardInfo.expiryYear &&
                    cardInfo.expiryMonth &&
                    cardInfo.expiryMonth + "/" + cardInfo.expiryYear,
                cvv: cardInfo.cvv,
                email: cardInfo.email,
                phone: cardInfo.phone,
                address1: cardInfo.address1,
                address2: cardInfo.address2,
                city: cardInfo.city,
                state: cardInfo.state,
                zip: cardInfo.zip,
            }, onSubmit: formSubmit, validateOnBlur: true }, function (_a) {
            var isValid = _a.isValid, dirty = _a.dirty, setFieldValue = _a.setFieldValue, handleChange = _a.handleChange, handleBlur = _a.handleBlur, setFieldTouched = _a.setFieldTouched;
            return (React.createElement(Form, { translate: "yes" },
                React.createElement(StyledWrapper, __assign({}, {
                    includeEmailField: includeEmailField,
                    includePhoneField: includePhoneField,
                }),
                    React.createElement(StyledSubheader, null, "Credit Card"),
                    map(function (inputDefinition) {
                        // TODO: https://upserve.atlassian.net/browse/HQ-7934
                        // if (inputDefinition.name === "gratuity-placeholder") {
                        //   return (
                        //     <GratuityComponent
                        //       key="gratuity component"
                        //       merchantInfo={merchantInfo}
                        //       paymentInfo={paymentInfo}
                        //       setTip={setTip}
                        //       setCustomTipError={setCustomTipError}
                        //       customTipError={customTipError}
                        //     />
                        //   );
                        // }
                        function makeControl(input) {
                            return (React.createElement(StyledFormControl, { className: input.name, key: input.name, gridArea: input.name },
                                React.createElement(Field, { name: input.name, validate: input.validate }, function (_a) {
                                    var meta = _a.meta;
                                    return (React.createElement(MuiTextfield, { error: meta.error && meta.touched, errorMsg: meta.error && meta.touched ? meta.error : "", required: !equals(input.name, "phone") &&
                                            !equals(input.name, "email") &&
                                            !equals(input.name, "address2"), name: input.name, label: input.label, value: meta.value, InputProps: {
                                            autoComplete: input.autocomplete,
                                            pattern: input.pattern,
                                            min: input.min,
                                            max: input.max,
                                        }, inputRef: input.ref, placeholder: input.placeholder, maxLength: input.maxLength, onChange: function (event) {
                                            if (input.onChange) {
                                                input.onChange(event, setFieldValue);
                                            }
                                            else
                                                handleChange(event);
                                        }, onBlur: function (event) {
                                            if (input.onBlur) {
                                                input.onBlur(event, setFieldValue, setFieldTouched);
                                            }
                                            else
                                                handleBlur(event);
                                        }, type: input.type }));
                                })));
                        }
                        return makeControl(inputDefinition);
                    }, inputs),
                    React.createElement("div", { className: "upserve-dgc-terms", style: { gridArea: "terms" } },
                        React.createElement("p", null,
                            "By clicking on \u201CSubmit Order\u201D you\u2019ll agree to the",
                            React.createElement("br", null),
                            React.createElement("a", { href: "https://assets-upserve.s3.amazonaws.com/terms-and-conditions/digital-gift-cards-terms-and-conditions.html", rel: "noopener noreferrer", target: "_blank" }, "Terms and Conditions"),
                            ", and the credit card above will be charged.")),
                    React.createElement(StyledFormButton, null,
                        paymentError,
                        React.createElement("button", { type: "submit", disabled: submitDisabled(isValid, dirty) ||
                                externalSubmitDisabled === true },
                            "Submit Order (", "" + paymentInfo.balanceDue.format(),
                            ")")))));
        })));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
